// components/views/claim/JobPreview.jsx
import React, { Component } from 'react';
import { convertFromUTC } from '../../../util/convert_timezone';

class JobPreview extends Component {
  render() {
    const { jobDetails, onNext } = this.props;

    if (!jobDetails) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading job details...</p>
          </div>
        </div>
      );
    }

    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
        {/* Hero Section with Jobvious Branding */}
        <div className="bg-gradient-to-r from-teal-500 to-teal-600 text-white px-4 py-8">
          <div className="max-w-md mx-auto text-center">
            {/* Jobvious Logo - Add your logo file here and make it a link */}
            <div className="mb-6">
              <a href="/" className="inline-block bg-white rounded-lg px-6 py-3 shadow-lg">
                <div className="flex items-center justify-center space-x-1">
                  <span className="text-gray-800 text-xl font-bold" style={{fontFamily: 'Montserrat, sans-serif'}}>
                    Job
                  </span>
                  <span className="text-orange-500 text-xl font-bold" style={{fontFamily: 'Montserrat, sans-serif'}}>
                    v
                  </span>
                  <div className="text-orange-500 text-xl font-bold mx-1">
                    <svg width="12" height="16" viewBox="0 0 12 16" fill="currentColor">
                      <path d="M2 8L6 12L10 8L6 4L2 8Z"/>
                    </svg>
                  </div>
                  <span className="text-gray-800 text-xl font-bold" style={{fontFamily: 'Montserrat, sans-serif'}}>
                    ious
                  </span>
                </div>
              </a>
            </div>
            
            <div className="mb-4">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-white bg-opacity-20 rounded-full mb-4">
                <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <h1 className="text-2xl font-bold mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>
                You've Been Selected!
              </h1>
              <p className="text-teal-100 text-lg" style={{fontFamily: 'Lato, sans-serif'}}>
                A premium automotive job opportunity awaits
              </p>
            </div>
          </div>
        </div>

        {/* Earnings Highlight */}
        <div className="px-4 -mt-6 relative z-10">
          <div className="max-w-md mx-auto">
            <div className="bg-white rounded-xl shadow-lg border-l-4 border-orange-400 p-6 mb-6">
              <div className="text-center">
                <div className="text-sm text-gray-600 mb-1" style={{fontFamily: 'Lato, sans-serif'}}>
                  Your Earnings
                </div>
                <div className="text-4xl font-bold text-orange-500 mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>
                  ${jobDetails.jobTotal}
                </div>
                <div className="text-sm text-gray-500" style={{fontFamily: 'Lato, sans-serif'}}>
                  Guaranteed payment upon completion
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Job Details */}
        <div className="px-4 pb-6">
          <div className="max-w-md mx-auto">
            <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-4" style={{fontFamily: 'Montserrat, sans-serif'}}>
                Job Overview
              </h2>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M4 3a2 2 0 100 4h12a2 2 0 100-4H4z"/>
                      <path fillRule="evenodd" d="M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <div className="flex-1">
                    <div className="text-sm font-medium text-gray-800" style={{fontFamily: 'Montserrat, sans-serif'}}>
                      Service Required
                    </div>
                    <div className="text-gray-600" style={{fontFamily: 'Lato, sans-serif'}}>
                      {jobDetails.serviceRequested}
                    </div>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-teal-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <div className="flex-1">
                    <div className="text-sm font-medium text-gray-800" style={{fontFamily: 'Montserrat, sans-serif'}}>
                      Location
                    </div>
                    <div className="text-gray-600" style={{fontFamily: 'Lato, sans-serif'}}>
                      Local area pickup
                    </div>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <div className="flex-1">
                    <div className="text-sm font-medium text-gray-800" style={{fontFamily: 'Montserrat, sans-serif'}}>
                      Timeline
                    </div>
                    <div className="text-gray-600" style={{fontFamily: 'Lato, sans-serif'}}>
                      Start by {convertFromUTC(jobDetails.availableDate).format('MMM Do, YYYY')}
                      {jobDetails.dueDate && (
                        <><br />Complete by {convertFromUTC(jobDetails.dueDate).format('MMM Do, YYYY')}</>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Why Jobvious */}
            <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4" style={{fontFamily: 'Montserrat, sans-serif'}}>
                Why Choose Jobvious?
              </h3>
              
              <div className="grid grid-cols-2 gap-4">
                <div className="text-center">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2">
                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                  </div>
                  <div className="text-sm font-medium text-gray-800" style={{fontFamily: 'Montserrat, sans-serif'}}>
                    Guaranteed Payment
                  </div>
                  <div className="text-xs text-gray-500 mt-1" style={{fontFamily: 'Lato, sans-serif'}}>
                    No collections hassle
                  </div>
                </div>

                <div className="text-center">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
                    <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                    </svg>
                  </div>
                  <div className="text-sm font-medium text-gray-800" style={{fontFamily: 'Montserrat, sans-serif'}}>
                    No Paperwork
                  </div>
                  <div className="text-xs text-gray-500 mt-1" style={{fontFamily: 'Lato, sans-serif'}}>
                    We handle invoicing
                  </div>
                </div>

                <div className="text-center">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-2">
                    <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2V6"/>
                    </svg>
                  </div>
                  <div className="text-sm font-medium text-gray-800" style={{fontFamily: 'Montserrat, sans-serif'}}>
                    Quality Network
                  </div>
                  <div className="text-xs text-gray-500 mt-1" style={{fontFamily: 'Lato, sans-serif'}}>
                    Vetted dealerships
                  </div>
                </div>

                <div className="text-center">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-2">
                    <svg className="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
                    </svg>
                  </div>
                  <div className="text-sm font-medium text-gray-800" style={{fontFamily: 'Montserrat, sans-serif'}}>
                    Fast Track
                  </div>
                  <div className="text-xs text-gray-500 mt-1" style={{fontFamily: 'Lato, sans-serif'}}>
                    Quick job completion
                  </div>
                </div>
              </div>
            </div>

            {/* Important Notice */}
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg className="w-3 h-3 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd"/>
                  </svg>
                </div>
                <div className="flex-1">
                  <h4 className="text-sm font-semibold text-blue-800 mb-1" style={{fontFamily: 'Montserrat, sans-serif'}}>
                    Next Steps
                  </h4>
                  <ul className="text-sm text-blue-700 space-y-1" style={{fontFamily: 'Lato, sans-serif'}}>
                    <li>• Dealer details revealed after claiming</li>
                    <li>• Must start within 48 hours</li>
                    <li>• Fixed rate - no negotiations</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <div className="text-center mb-6">
              <button 
                onClick={onNext}
                className="w-full bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600 text-white font-bold py-4 px-8 rounded-xl shadow-lg transform transition hover:scale-105 focus:outline-none focus:ring-4 focus:ring-orange-300"
                style={{fontFamily: 'Montserrat, sans-serif'}}
              >
                <span className="flex items-center justify-center">
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
                  </svg>
                  Claim This Opportunity
                </span>
              </button>
              
              <p className="text-sm text-gray-500 mt-3" style={{fontFamily: 'Lato, sans-serif'}}>
                Review terms and complete quick registration next
              </p>
            </div>

            {/* Trust Footer */}
            <div className="text-center pb-6">
              <div className="flex items-center justify-center space-x-2 text-gray-400 text-sm">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd"/>
                </svg>
                <span style={{fontFamily: 'Lato, sans-serif'}}>Secure job claiming powered by Jobvious</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default JobPreview;